<div class="loadingbg p-48" fxLayout="column" fxLayoutGap="24px" fxLayoutAlign="center center">
    <mat-spinner [diameter]="56"></mat-spinner>
    <div class="title">
        <div matDialogTitle>{{title}}</div>
        <div [innerHTML]="content" mat-dialog-content></div>
    </div>
</div>